module.exports = __webpack_public_path__ + "img/dinner.db83c5a1.png";